function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_993",
  "data-name": "Group 993",
  transform: "translate(-271 -16)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_989",
  "data-name": "Group 989",
  transform: "translate(63.391 -69.03)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_599",
  "data-name": "Path 599",
  d: "M2.9-17.366H9.242V-23.71H2.9Z",
  transform: "translate(209.711 114.24)",
  fill: "rgba(0,0,0,0)",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_602",
  "data-name": "Path 602",
  d: "M6.32-20.169H7.785",
  transform: "translate(208.047 113.573)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_990",
  "data-name": "Group 990",
  transform: "translate(63.391 -69.03)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_600",
  "data-name": "Path 600",
  d: "M2.9-3.93H9.242v-6.344H2.9Z",
  transform: "translate(209.711 109.961)",
  fill: "rgba(0,0,0,0)",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_603",
  "data-name": "Path 603",
  d: "M6.32-6.733H8.426",
  transform: "translate(208.047 110.9)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_991",
  "data-name": "Group 991",
  transform: "translate(63.391 -69.03)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_601",
  "data-name": "Path 601",
  d: "M17-17.366h6.344V-23.71H17Z",
  transform: "translate(205.305 114.24)",
  fill: "rgba(0,0,0,0)",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_604",
  "data-name": "Path 604",
  d: "M20.418-20.169h1.154",
  transform: "translate(205.359 113.573)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_992",
  "data-name": "Group 992",
  transform: "translate(63.391 -69.03)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605",
  "data-name": "Path 605",
  d: "M17.207-11.885h4.067v6.151H15.188v-3.08h3.819",
  transform: "translate(207.113 111.765)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_701",
  "data-name": "Path 701",
  d: "M.5-22.4v-4.939A3.113,3.113,0,0,1,3.662-30.4H8.507",
  transform: "translate(271.5 47.399)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_702",
  "data-name": "Path 702",
  d: "M20.576-30.237h4.912a3.144,3.144,0,0,1,3.095,3.191v4.809",
  transform: "translate(267.418 47.366)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_703",
  "data-name": "Path 703",
  d: "M28.821-10.911V-6A3.058,3.058,0,0,1,27.9-3.817a3.2,3.2,0,0,1-2.234.905H20.9",
  transform: "translate(267.18 43.911)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_704",
  "data-name": "Path 704",
  d: "M8.5-2.75H3.556A3.008,3.008,0,0,1,1.4-3.674,3.206,3.206,0,0,1,.5-5.9V-10.75",
  transform: "translate(271.5 43.75)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgScan = function SvgScan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.001,
    height: 26,
    viewBox: "0 0 26.001 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scan.f6083e6c.svg";
export { ForwardRef as ReactComponent };